module.exports = __webpack_public_path__ + "img/img21.b24e4cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/02/img21.png
// module id = 198
// module chunks = 0